import BASE_RULE from '../baseRule';
import {SearchTypeMetadata, MetadataType} from './constants';
import type {MetadataRule} from './types';

export const metadataRuleDefaults: MetadataRule = {
	...BASE_RULE,
	elementType: SearchTypeMetadata,
	elementSubType1: MetadataType.MATCH_ALL_WILD_CARDS,
};

export default metadataRuleDefaults;
